import { render, staticRenderFns } from "./address-tile.vue?vue&type=template&id=13893204&scoped=true&"
import script from "./address-tile.vue?vue&type=script&lang=js&"
export * from "./address-tile.vue?vue&type=script&lang=js&"
import style0 from "./address-tile.vue?vue&type=style&index=0&id=13893204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13893204",
  null
  
)

export default component.exports